import { ReactElement, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getUserProfile } from '~/helpers/userProfile';
import { useFilterContext } from '~/pages/NewOverview/contexts/FilterContext';
import { handleEfficiencyRatingFilter } from '~/pages/NewOverview/helpers/filters';
import { EfficiencyRating } from '~/providers/types/overview';
import { CATEGORY_ORDER } from '../../constants';
import { EfficiencyCategory } from '../../types';
import { EnergyEfficiencyRow } from './Row';
import { EfficiencyTable } from './styles';

interface EnergyEfficiencyTableProps {
  data: EfficiencyRating | undefined;
  disabled: boolean;
}

export function EnergyEfficiencyTable({
  data,
  disabled,
}: Readonly<EnergyEfficiencyTableProps>): ReactElement {
  const [profile] = useState(getUserProfile());
  const history = useHistory();
  const { clients, selectedOptions } = useFilterContext();

  function onClickRow(category: EfficiencyCategory): void {
    history.push('/analise/energia?tipo=energy',
      handleEfficiencyRatingFilter(clients, selectedOptions, profile, category));
  }

  return (
    <EfficiencyTable>
      <tbody>
        {CATEGORY_ORDER.map((category) => (
          <EnergyEfficiencyRow
            key={`row-${category.toLowerCase()}`}
            category={category}
            percentage={data?.[category].PERCENTAGE ?? 0}
            units={data?.[category].UNITS ?? 0}
            onClickRow={onClickRow}
            disabled={disabled || !data}
          />
        ))}
      </tbody>
    </EfficiencyTable>
  );
}
